import { Factory } from 'rosie';

Factory.define('Reports').attr('name', 'REPORTS');

Factory.define('ReportsWithDefaults')
  .extend('Reports')
  .attr('aggregationLevel', 'daily')
  .attr('slug', 'summary')
  .attr('timezone', '');
